<template>
  <v-container fluid id="docForm">
    <v-row dense id="po">
      <v-col cols="12" xs="12" md="3">
        <v-autocomplete
          name="goodsReceiptSupplier"
          dense
          outlined
          v-model="record.CardCode"
          :items="suppliers"
          label="Supplier"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-text-field
          name="goodsReceiptOrderNo"
          v-model="record.DocNum"
          outlined
          dense
          filled
          readonly
          label="Order No"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <DatePicker @date="setDate" :myDate="record.DocDate" :title="`Date`"></DatePicker>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-autocomplete
          name="goodsReceiptStore"
          dense
          outlined
          v-model="storeId"
          :items="stores"
          label="Store"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-alert
          v-if="orderItems.length == 0 && docCreate == true"
          type="warning"
        >You have not added any Item.</v-alert>

        <v-data-table
          light
          dense
          :items-per-page="pageItems"
          :headers="headers"
          :items="orderItems"
          item-key="o_i_t_m_s_id"
          hide-default-footer
          @item-selected="selectedRow"
          v-model="selectedItems"
          disable-sort
        >
          <template v-slot:item.Name="{ item }">
            <v-text-field
              v-show="docCreate == false"
              v-if="item.product"
              class="orderInput"
              single-line
              outlined
              dense
              readonly
              filled
              v-model="item.product.Name"
              name="goodsReceiptProductName"
              style="width: 300px"
            ></v-text-field>

            <v-autocomplete
              v-show="docCreate == true"
              style="width: 350px"
              dense
              outlined
              single-line
              v-model="item.id"
              :items="products"
              label="Select Product"
              name="goodsReceiptProductName2"
              item-text="product.Name"
              item-value="id"
              @change="setOrderItem(item)"
            ></v-autocomplete>
          </template>

          <template v-slot:item.Quantity="{ item }">
            <v-text-field
              name="goodsReceiptQuantity"
              :filled="docCreate==false?true:false"
              :readonly="docCreate==false?true:false"
              class="orderInput"
              @input="inputChanged(item)"
              single-line
              outlined
              dense
              v-model="item.Quantity"
            ></v-text-field>
          </template>

          <template v-slot:item.TaxId="{ item }">
            <v-autocomplete
              name="goodsReceiptTaxId"
              dense
              outlined
              single-line
              v-model="item.TaxId"
              :items="taxGroups"
              label="Tax"
              item-text="Name"
              item-value="id"
              @change="inputChanged(item)"
            ></v-autocomplete>
          </template>

          <template v-slot:item.UomEntry="{ item }">
            <v-text-field
              name="goodsReceiptUom"
              filled
              outlined
              readonly
              dense
              value="Unit(s)"
              v-if="item.ManualStatus == 'Y'"
            ></v-text-field>
            <v-autocomplete
              name="goodsReceiptUomEntry"
              v-else
              dense
              outlined
              single-line
              v-model="item.UomEntry"
              :items="item.ugp1"
              label="UOM"
              item-text="uomentry.UomName"
              item-value="uomentry.id"
            ></v-autocomplete>
          </template>

          <template v-slot:item.Price="{ item }">
            <v-text-field
              name="goodsReceiptBuyingPrice"
              :filled="docCreate==false?true:false"
              :readonly="docCreate==false?true:false"
              class="orderInput"
              @input="inputChanged(item)"
              single-line
              outlined
              dense
              v-model="item.Price"
            ></v-text-field>
          </template>

          <template v-slot:item.DisplayTotal="{ item }">
            <v-text-field
              name="goodsReceiptDisplayTotal"
              class="orderInput"
              single-line
              outlined
              dense
              filled
              readonly
              v-model="item.DisplayTotal"
            ></v-text-field>
          </template>

          <!-- action template -->
          <template v-slot:item.action="{ item }">
            <v-btn @click="deleteRow(item)" color="red" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <!-- end -->
        </v-data-table>

        <v-btn v-show="docCreate == true" @click="addRow" small color="primary" class="mt-1">
          <v-icon left>mdi-plus</v-icon>Add Row
        </v-btn>
      </v-col>

      <v-col cols="3">
        <v-text-field
          name="goodsReceiptTotalDisplayAmount"
          v-model="totalDisplayAmount"
          label="Total"
          filled
          dense
          outlined
          readonly
        ></v-text-field>

        <v-text-field
          v-if="docCreate == true"
          class="mt-2"
          v-model="SumApplied"
          label="Amount Paid"
          dense
          outlined
          name="goodsReceiptSumApplied"
        ></v-text-field>

        <v-text-field
          v-else
          name="goodsReceiptPaidSum"
          class="mt-2"
          v-model="PaidSum"
          label="Amount Paid"
          dense
          readonly
          filled
          outlined
        ></v-text-field>

        <v-text-field
          name="goodsReceiptDisplayBalance"
          class="mt-2"
          v-model="displayBalance"
          label="Balance"
          filled
          dense
          outlined
          readonly
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn v-if="docCreate == true" color="accent" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>
    </v-row>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>


<script>
export default {
  name: "NewPurchaseOrder",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
    copyStatus: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    taxGroups: [],
    selectedProduct: null,
    SumApplied: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    orderItems: [],
    suppliers: [],
    products: [],
    stores: [],
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      // { text: "Purchase UOM", value: "UomEntry" },
      { text: "Price", value: "Price" },
      // { text: "Tax", value: "TaxId" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" },
    ],
  }),
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map((item) => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    balance() {
      let sum = 0;
      if (this.SumApplied) {
        sum = this.SumApplied;
      }
      return this.totalAmount - parseFloat(sum);
    },
    displayBalance() {
      let bal = 0;
      if (this.docCreate == true) {
        bal = this.balance.toLocaleString();
      } else {
        bal = this.record.Balance;
      }
      return bal;
    },
    totalDisplayAmount() {
      return this.totalAmount.toLocaleString();
    },
    PaidSum() {
      let paid = 0;
      if (this.record.PaidSum) {
        paid = this.record.PaidSum.toLocaleString();
      }
      return paid;
    },
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          row.DisplayTotal = row.LineTotal.toLocaleString();
          products.push(row);
        }
        this.orderItems = products;
      }
    },
    setDate(date) {
      this.record.DocDate = date;
    },
    addRow() {
      let initArray = [];
      const LineNum = new Date().getTime();

      const details = {
        LineNum: LineNum,
        Name: null,
        Quantity: null,
        Price: null,
        ref1: null,
        TaxId: this.taxGroups[0].id,
        LineTotal: 0,
        DiscSum: null,
        UomEntry: null,
        ManualStatus: null,
        ugp1: [],
        DisplayTotal: 0,
      };
      initArray.push(details);
      this.orderItems = [...this.orderItems, ...initArray];
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find((record) => {
        return record.o_i_t_m_s_id === item.o_i_t_m_s_id;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
      this.activeRow = null;
      this.selectedItems = [];
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    inputChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const Total = Price * Quantity;
      // add tax
      const tax = this.taxGroups.find((record) => {
        return record.id === data.TaxId;
      });

      let taxAmount = 0;
      let taxRate = 0;
      if (tax) {
        taxRate = tax.Rate;
        taxAmount = (taxRate / 100) * Total;
      }

      const LineTotal = Total + taxAmount;
      // end
      const DisplayTotal = LineTotal.toLocaleString();
      // find item
      const currentItem = this.orderItems.find((record) => {
        return record.LineNum === data.LineNum;
      });

      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find

      // update record
      currentItem.TaxRate = taxRate;
      currentItem.TaxAmount = taxAmount;
      currentItem.LineTotal = LineTotal;
      currentItem.DisplayTotal = DisplayTotal;
      this.orderItems[pos] = currentItem;
    },
    setOrderItem(data) {
      const itm2Id = data.id;
      const itm2 = this.products.find((record) => {
        return record.id == itm2Id;
      });
      const store_id = this.activeStore;

      const currentItem = this.orderItems.find((record) => {
        return record.LineNum === data.LineNum;
      });

      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }

      currentItem.ManualStatus = itm2.product.ugpentry.IsManual;
      currentItem.UomEntry = itm2.product.PUoMEntry;
      currentItem.ugp1 = itm2.product.ugpentry.ugp1;
      // set selling price and store
      currentItem.o_i_t_m_s_id = itm2.product.id;
      currentItem.Name = itm2.product.Name;
      currentItem.Price = null;
      currentItem.Quantity = null;
      currentItem.LineTotal = 0;
      currentItem.DisplayTotal = 0;
      currentItem.DiscSum = 0;
      currentItem.store_id = store_id;
      this.orderItems[pos] = currentItem;
      // end of check
      this.selectedProduct = "";
    },
    sendData() {
      if (this.orderItems.length > 0) {
        if (this.record.CardCode) {
          const data = this.record;
          data.rows = this.orderItems;
          data.TargetType = null;
          data.BaseType = null;
          data.BaseEntry = null;
          data.ObjType = 11;
          data.DocTotal = this.totalAmount;
          data.DocNum = this.record.DocNum;
          data.DiscSum = 0;
          data.BatchID = this.storeId;
          data.store_id = this.storeId;
          // set payments
          let payments = [];
          const paidAmount = this.SumApplied;
          let paymentData = { o_a_c_t_s_id: 1, SumApplied: paidAmount };
          payments.push(paymentData);
          data.payments = payments;
          // end
          this.$store.commit("btnLoader", true);
          this.$emit("data", data);
        } else {
          this.$refs.snackbar.show("Please select supplier", "red");
        }
      } else {
        this.$refs.snackbar.show("You must have at least one product", "red");
      }
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProducts() {
      const self = this;
      const id = this.activeStore;
      this.$store
        .dispatch("get", `/stores/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData.itm2;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData.DefaultStockStore) {
              self.storeId = res.ResponseData.DefaultStockStore;
              if (self.docCreate) {
                self.record.DocDate = new Date().toISOString().substr(0, 10);
              }
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/12`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (self.docCreate == true) {
              self.record = {
                ...self.record,
                DocNum: res.ResponseData.NextNumber,
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDefaultRow() {
      // get taxes first
      const self = this;
      this.$store
        .dispatch("get", `/taxgroups/I`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.taxGroups = res.ResponseData;

            if (self.docCreate == true) {
              let initArray = [];
              const LineNum = new Date().getTime();
              const details = {
                LineNum: LineNum,
                Name: null,
                Quantity: null,
                Price: null,
                ref1: null,
                TaxId: res.ResponseData[0].id,
                TaxRate: null,
                TaxAmount: null,
                LineTotal: 0,
                DiscSum: null,
                DisplayTotal: 0,
              };
              initArray.push(details);
              self.orderItems = [...this.orderItems, ...initArray];
            }
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
      // then set
    },
  },
  created() {
    this.setDefaultRow();

    Promise.all([
      this.getSuppliers(),
      this.getProducts(),
      this.getStores(),
      this.getGenSettings(),
      this.getDocNum(),
    ]);
  },
};
</script>

<style  scoped>
/* .v-text-field__details {
  display: none !important;
} */
</style>